import request from './request'

export function fetchSiteSettings () {
  return request.get('/site/settings')
}

export function updateSiteSettings (payload) {
  return request.put('/site/settings', payload)
}
